import { SmallButton, InputIcon } from "@sellar-io/components";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { ReactElement, useState } from "react";
import { useDebounceValue } from "usehooks-ts";
import { Icon } from "../../../../components";
import { InputContainer, InputText } from "@sellar-io/components";
import {
  NavigationBarMenu,
  NavigationBarSubHeader,
} from "../../../../components/navigation/NavigationBar";
import { NavigationTabList } from "../../../../components/navigationTabs/NavigationTabList";
import { NavigationTabPanels } from "../../../../components/navigationTabs/NavigationTabPanels";
import { NavigationTabGroup } from "../../../../components/navigationTabs/NavigationTabsGroup";
import { NEW_PRODUCT } from "../../../../constants/routes";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { ProductListV2 } from "./ProductListV2";
import { TermsAndConditionsDialog } from "../../../settings/termsAndConditions/TermsAndConditionsDialog";
import { useNavigate } from "react-router";
import { useShowTermsAndConditionsModal } from "../../../../hooks/useShowTermsAndConditionsModal";

dayjs.extend(relativeTime);

export const ProductListV2Tabs = (): ReactElement => {
  const navigate = useNavigate();
  const { business } = useSellarCurrentBusiness();
  if (!business?.Supplier) throw new Error("Must be a supplier");

  const [searchValue, setSearchValue] = useState("");
  const [termsActive, setTermsActive] = useState(false);

  const [debouncedSearchValue] = useDebounceValue(searchValue, 500);

  const termsAndConditionsEnabled = useShowTermsAndConditionsModal();

  const handleNewProductClick = () => {
    if (termsAndConditionsEnabled) {
      setTermsActive(true);
    } else {
      navigate(NEW_PRODUCT);
    }
  };

  const handleTermsDismiss = (accepted: boolean) => {
    setTermsActive(false);
    if (accepted) navigate(NEW_PRODUCT);
  };

  return (
    <>
      <NavigationTabGroup
        tabs={["Active", "Inactive"] as const}
        panelFactory={(tab) => {
          switch (tab) {
            case "Active":
              return (
                <ProductListV2
                  active={true}
                  searchValue={debouncedSearchValue}
                />
              );
            case "Inactive":
              return (
                <ProductListV2
                  active={false}
                  searchValue={debouncedSearchValue}
                />
              );
            default:
              return null;
          }
        }}
      >
        <NavigationBarMenu
          title={"Product List"}
          borderBottom={false}
          rightComponent={
            <SmallButton onClick={handleNewProductClick}>
              <Icon icon={"PLUS"} size={0.7} /> New
            </SmallButton>
          }
        />
        <NavigationBarSubHeader>
          <div className={"px-2 pb-2"}>
            <InputContainer>
              <InputIcon icon={"MAGNIFY"} />
              <InputText
                placeholder={"Search for a product..."}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </InputContainer>
          </div>
          <NavigationTabList />
        </NavigationBarSubHeader>
        <NavigationTabPanels />
      </NavigationTabGroup>
      <TermsAndConditionsDialog
        active={termsActive}
        onDismiss={handleTermsDismiss}
      />
    </>
  );
};
